"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useAddFeedback, useFeedback } from "@/features/engagement/hooks/use-feedback";
type FeedbackProps = {
  slug: string;
};
function Feedback(t0) {
  const $ = _c(4);
  const {
    slug
  } = t0;
  const {
    data: feedback,
    isPending,
    isError
  } = useFeedback(slug);
  const {
    mutate: addFeedback
  } = useAddFeedback(slug);
  if (isPending) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p>Loading...</p>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (isError) {
    return null;
  }
  let t1;
  if ($[1] !== addFeedback || $[2] !== feedback) {
    t1 = feedback ? <p>Thanks for your feedback!</p> : <form action={formData => addFeedback(formData)} className="flex flex-col gap-4"><Label htmlFor="feedback">Feedback</Label><Textarea name="feedback" /><Button type="submit">Submit</Button></form>;
    $[1] = addFeedback;
    $[2] = feedback;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export default Feedback;